<template>
  <div class="about">
    <div
      style="
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.45);
        z-index: 92;
      "
      v-if="showClassify"
    ></div>


    <div
      style="position: fixed; top: 0; left: 0; right: 0; z-index: 999"
      class="payment"
    >
    <van-nav-bar title="商标搜索">
        <template #right>
          <!-- <img
            src="@/assets/images/export.png"
            style="width: 26px"
            @click="goExport"
          /> -->
          <div style="color: #329c39" @click="doShareShow">
            <van-icon name="share-o" color="#329c39" /> 分享
          </div>
        </template>
      </van-nav-bar>
    </div>

    <div
      class="payment"
      style="padding-top: 46px;"
    >
   
      <!--如果是国际商标，则要展示国旗-->
      <div class="inter" v-show="is_intern">
        <van-tabs v-model="active" @click="activeChange">
          <van-tab style="" v-for="item in interList" :key="item.name">
            <template #title>
              <div class="t-al-c">
                <img class="in-bl" style="width: 36px" :src="item.img" /><br />
                <span>{{ item.name }}</span>
              </div>
            </template>
          </van-tab>
        </van-tabs>
      </div>



      <!-- 商标类型 -->
      <div
        v-if="false"
        class="cus-row cus-row-v-m"
        style="
          background: #ffffff;
          border-bottom: 1px solid #f1f1f1;
          border-top: 1px solid #f1f1f1;
        "
      >
        <div
          class="cus-row-col-10"
          style="
            font-size: 12px;
            line-height: 43px;
            border-left: 1px solid #f1f1f1;
            box-sizing: border-box;
            text-align: left;
            padding-left: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          "
        >
          商标类型：全部
        </div>

        <div
          class="cus-row-col-2"
          style="text-align: right; font-size: 18px"
        >
          <van-icon
            name="arrow"
            style="margin-right: 24px"
          />
        </div>
      </div>

      <!-- 搜索类型 -->
      <div
        class="cus-row cus-row-v-m"
        style="
          background: #ffffff;
          border-bottom: 1px solid #f1f1f1;
          border-top: 1px solid #f1f1f1;
        "
      >
        <div
          class="cus-row-col-10"
          style="
            font-size: 12px;
            line-height: 43px;
            border-left: 1px solid #f1f1f1;
            box-sizing: border-box;
            text-align: left;
            padding-left: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          "
          @click="showSearchTypePopup"
        >
          搜索类型：{{ currentSearchType.name }}
        </div>

        <div
          class="cus-row-col-2"
          style="text-align: right; font-size: 18px"
          @click="showSearchTypePopup"
        >
          <van-icon
            name="arrow"
            style="margin-right: 24px"
          />
        </div>
      </div>

      <div
        class="cus-row cus-row-v-m"
        style="
          background: #ffffff;
          border-bottom: 1px solid #f1f1f1;
          border-top: 1px solid #f1f1f1;
        "
      >
        <!--多出部分用省略号表示,点击可以编辑详情-->

        <div
          class="cus-row-col-10"
          style="
            font-size: 12px;
            line-height: 43px;
            border-left: 1px solid #f1f1f1;
            box-sizing: border-box;
            text-align: left;
            padding-left: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          "
          @click="showClassifyPopup"
        >
          商标类别：{{ selected_classify_texts }}
        </div>

        <div
          class="cus-row-col-2"
          style="text-align: right; font-size: 18px"
          @click="showClassifyPopup"
        >
          <van-icon
            name="arrow"
            style="margin-right: 24px"
          />
        </div>
      </div>

      <!-- 关键词输入 -->
      <div
        class="cus-row cus-row-v-m"
        style="
          background: #ffffff;
          border-bottom: 1px solid #f1f1f1;
          border-top: 1px solid #f1f1f1;
        "
      >
        <div
          class="cus-row-col-10"
          style="
            font-size: 12px;
            line-height: 43px;
            border-left: 1px solid #f1f1f1;
            box-sizing: border-box;
            text-align: left;
            padding-left: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          "
        >
          <span style="color: #666; margin-right: 8px;">关键词：</span>
          <input
            v-model="keyword"
            :placeholder="keywordPlaceholder"
            style="
              border: none;
              outline: none;
              background: transparent;
              font-size: 12px;
              color: #333;
              width: calc(100% - 60px);
            "
          />
        </div>

        <div
          class="cus-row-col-2"
          style="text-align: right; font-size: 18px"
        >
          <van-icon
            name="clear"
            style="margin-right: 24px; color: #999;"
            @click="keyword = ''"
            v-if="keyword"
          />
        </div>
      </div>

      <!-- 开始搜索按钮 -->
      <div
        style="
          padding: 12px 16px 8px 16px;
          background: #ffffff;
          line-height: 0;
        "
      >
        <van-button
          type="primary"
          size="large"
          style="
            width: 100%;
            height: 44px;
            background-color: #4285f4;
            border-color: #4285f4;
            font-size: 15px;
            font-weight: 500;
          "
          @click="setTmpFilterData"
        >
          开始搜索
        </van-button>
      </div>


    </div>

    <div
      style="padding: 8px; background: #ffffff; text-align: left;"
    >

      <div class="in-bl-line home-brand-items payment-list-container" style="position: relative">
        <div
          v-for="(it, ind) in list"
          :key="it.id || ind"
          class="payment-item-wrapper"
        >

        <!-- <brand-item :reg_no="it.reg_no">

</brand-item> -->

          <!--设置选中功能-->
          <div
            style="padding: 0; position: relative"
            class="real-box"
            :data-reg_no="it.reg_no"
          >

            <brand-item :reg_no="it.reg_no" layout="grid"></brand-item>
     
            <!--TODO 显示多类别 显示预留信息-->

            <!-- <a
              style="
                position: absolute;
                top: 24px;
                right: 12px;
                color: rgb(255, 255, 255);
                background-color: rgb(243, 146, 68);
                font-size: 12px;
                line-height: 20px;
                padding: 0px 6px;
                border-radius: 20px;
                z-index: 9;
              "
              v-if="it.tit_count > 1"
              >多类别</a
            >

            <a
              style="
                position: absolute;
                top: 24px;
                right: 67px;
                color: #ffffff;
                background-color: green;
                font-size: 12px;
                line-height: 20px;
                padding: 0 6px;
                border-radius: 20px;
                z-index: 9;
              "
              v-if="it.is_reserved"
              @click="showReservedInfo(it)"
              >预留
            </a>

            <div style="padding-bottom: 100%; position: relative">
              <img
                class="ab-t-t-x-y"
                style="width: 80%"
                :src="$common.polishingImg(visitPath(it.bg))"
              />
            </div>

            <div
              style="
                color: #949494;
                font-size: 14px;
                line-height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
              "
            >
              【{{ it.classify }}类】- {{ it.tit }}
            </div> -->

          

            <!-- 自有 -->
            


          </div>
        </div>
      </div>

      <infinite-loading
        @infinite="infiniteHandler"
        :distance="200"
        ref="infiniteLoading"
      >
        <span slot="no-more" style="font-size: 12px"> 我们是有底线的 </span>
      </infinite-loading>
    </div>

    <van-popup
      v-model="show"
      position="right"
      style="width: 86%; height: 100%; background: #ffffff; z-index: 99999"
    >
      <!--字符、注册年限、组合类型、注册类型、年限进行筛选-->
      <div style="box-shadow: 0px 2px 5px #eeeeee">
        <van-cell title="" is-link value="关闭" @click="show = false" />
      </div>

      <!--用tab操作-->
      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        
            <div style="padding: 6px; text-align: left">
              <!--是否自有-->


              <div><div class="filter-title">
                注册号
              </div><div style="font-size: 0px;padding-right: 24px;margin-bottom: 12px;"><input
                      type="text"
                      class="cus_price_input"
                      v-model="reg_no_like"
                      placeholder="输入注册号，模糊搜素"
                    /></div></div>

              <div
                v-for="(item, index) in filter_data"
                :key="index"
                v-if="is_intern == item.is_intern && !item.hide"
              >
                <div class="filter-title">
                  {{ item.title }}
                </div>

                <div style="font-size: 0">
                  <div
                    :class="{ 'filter-item': true }"
                    v-for="(it, ind) in item.list"
                    :key="ind"
                  >
                    <span
                      @click="chosenFilter(index, ind)"
                      :class="{ active: it.checked }"
                      >{{ it.name }}</span
                    >
                  </div>

                  <!--自定义价格区间-->
                  <div
                    class="filter-item"
                    v-if="item.title == '价格'"
                    @click="inputBeginPrice"
                  >
                    <!--                      <span>334</span>-->

                    <input
                      type="text"
                      class="cus_price_input"
                      v-model="begin_price"
                      onfocus="this.blur()"
                      readonly
                    />
                  </div>

                  <div
                    class="filter-item"
                    v-if="item.title == '价格'"
                    @click="inputEndPrice"
                  >
                    <!--                      <span>334</span>-->

                    <input
                      class="cus_price_input"
                      v-model="end_price"
                      onfocus="this.blur()"
                      readonly
                    />
                  </div>
                </div>


                

                <!--自定义-->
              </div>
            </div>
        
      </div>

      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button
              type="danger"
              block
              style="background: #ffffff; color: #000000; border: none"
              @click="resetFilterData"
              >重置</van-button
            >
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="setTmpFilterData"
              >搜索</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>


     <van-calendar v-model:show="date_show" @confirm="onConfirm" style="z-index: 999999;"/>




     <van-popup position="top" v-model="puton_confirm_show">
      <div style="background-color: #ffffff; min-height: 80px; width: 100%">
        <div style="text-align: center; font-size: 18px; padding: 24px">
          商标备案
        </div>

        <van-form @submit="onPutonSubmit">
          <van-field
            v-model="puton_price"
            name="备案价格"
            label="备案价格"
            placeholder=""
          />

          <!--来源，是select-->
          <van-field name="radio" label="来源">
          <template #input>
              <van-radio-group v-model="source_type" direction="">
                <van-radio name="1" style="margin-bottom: 12px;">群求购</van-radio>
                <van-radio name="2" style="margin-bottom: 12px;">私下求购</van-radio>
                <van-radio name="3" style="margin-bottom: 12px;">手动添加</van-radio>
              </van-radio-group>
            </template>
          </van-field>


          <van-field
            v-model="puton_remark"
            placeholder="备注"
            rows="4"
            name=""
            label=""
            type="textarea"
          />
          <div style="margin: 16px">
            <van-button round block type="danger" native-type="submit"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </van-popup>



    <van-popup position="top" v-model="reserved_show">
      <div style="background-color: #ffffff; min-height: 80px; width: 100%">
        <div style="text-align: center; font-size: 18px; padding: 24px">
          商标预留
        </div>

        <van-form @submit="onSubmit">
          <van-field label="预留结束时间" v-model="time1" readonly @click="(res)=>{date_show=true}"/>

          <van-field
            v-model="username"
            name="姓名"
            label="姓名"
            placeholder="请填写姓名"
          />
          <van-field
            v-model="reserved_content"
            placeholder="强填写留言"
            rows="4"
            name="留言"
            label="留言"
            type="textarea"
          />
          <div style="margin: 16px">
            <van-button round block type="danger" native-type="submit"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </van-popup>


    <van-popup position="top" v-model="chosen_classify_flag">
      <div
        style="
          background-color: #ffffff;
          min-height: 80px;
          width: 100%;
          padding: 16px;
          box-sizing: border-box;
        "
      >
        <div style="font-size: 16px">已选择分类</div>

        <div style="text-align: left">
          <div
            v-for="(item, ind) in classifyConfig"
            style="display: inline-block; margin-right: 24px;font-size: 32px;"
          >
            <van-tag
              type="primary"
              closeable
              v-if="item.selected"
              @close="classifyUnSelected(item)"
            >
              {{ $common.paddingZero(item.id) + "类-" + item.name }}
            </van-tag>
          </div>
        </div>
      </div>
    </van-popup>

    <van-number-keyboard
      v-model="begin_price"
      :show="begin_price_show"
      :maxlength="6"
      @blur="begin_price_show = false"
      z-index="9999999"
      close-button-text="完成"
    />

    <van-number-keyboard
      v-model="end_price"
      :show="end_price_show"
      :maxlength="6"
      @blur="end_price_show = false"
      z-index="9999999"
      close-button-text="完成"
    />


    <!--左下角快速搜索-->

    <van-popup
        v-model="quick_search_flag"
        position="right"
        style="width: 82%; height: 100%; background: #ffffff; z-index: 99999"
    >

      <div style="box-shadow: 0px 2px 5px #eeeeee">
        <van-cell title="" is-link value="关闭" @click="quick_search_flag = false" />
      </div>


      <div>
        <!-- <van-search
            show-action
            placeholder="请输入商标注册号"
            v-model="quick_search_reg_no"
        >
          <template #action>
            <van-button type="primary" size="small" @click="searchRegNo">导出</van-button>
          </template>
        </van-search> -->


        <!--显示商标详情-->
        <div
            style="width: 50%; display: inline-block"
            class="item"
            v-if="!it"
        >

          <div
              style="padding: 6px; border: 1px solid #e6e6e6; position: relative;text-align: center;"
          >
            <!-- <img src="~@/assets/images/no_data.png" style="display: inline-block;width: 54px;margin-top: 32px;"/>

            <div style="font-size: 14px;color: #666666;margin-bottom: 32px;">暂无数据</div>-->
            </div> 

          </div>


        <div
            style="width: 50%; display: inline-block"
            class="item"
            v-if="it"
        >
          <!--设置选中功能-->
          <div
              style="padding: 6px; border: 1px solid #e6e6e6; position: relative"
          >
            <a
                style="
                position: absolute;
                top: 24px;
                right: 67px;
                color: #ffffff;
                background-color: green;
                font-size: 12px;
                line-height: 20px;
                padding: 0 6px;
                border-radius: 20px;
                z-index: 9;
              "
                v-if="it.is_reserved"
                @click="showReservedInfo(it)"
            >预留
            </a>

            <div style="padding-bottom: 100%; position: relative">
              <img
                  class="ab-t-t-x-y"
                  style="width: 80%"
                  :src="$common.polishingImg(visitPath(it.cover_img))"
              />
            </div>

            <div
                style="
                color: #949494;
                font-size: 14px;
                line-height: 30px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              【{{ it.classify }}类】- {{ it.tit }}
            </div>

            <div class="cus-row cus-row-v-m" style="margin: 12px 0">
              <div
                  class="cus-row-col-6 price-tag t-al-l"
                  style="font-weight: bold; font-size: 16px"
                  v-if="!is_five_phases && !it.is_reserved"
              >
                <span style="font-size: 12px">￥</span>{{ it.sum_indus_price }}
              </div>


              <div
                  class="cus-row-col-6 price-tag t-al-l"
                  style="font-weight: bold; font-size: 16px"
                  v-if="is_five_phases"
              >
                <span style="font-size: 12px">￥</span>{{ it.money2 }}
              </div>


              <div class="cus-row-col-6 t-al-r" @click.stop="goDetail(it)">
                <span style="color: #949494; font-size: 12px" class="in-bl-v-m"
                >查看详情 <van-icon name="arrow" />
                </span>
              </div>
            </div>

            <!-- 自有 -->
          </div>
        </div>



      </div>



    </van-popup>







    <van-popup position="top" class="product_detail" v-model="product_show" >
      <div
          style="
          background-color: #ffffff;
          min-height: 80px;
          width: 100%;
          padding: 16px;
        "
      >
        <div
            style="
            position: relative;
            font-size: 0;
            border-bottom: 1px solid #f1f1f1;
          "
        >
          <div style="padding-bottom: 55%; background: #ffffff">
            <div class="ab-t-t-x-y">
              <img
                  :src="$common.polishingImg(visitPath(detail.bg))"
                  style="width: 100%"
              />
            </div>
          </div>

          <div
              style="position: absolute; left: 16px; top: 16px"
              @click="goBack"
          >
            <div
                style="
                width: 36px;
                height: 36px;
                background: #7e7e7e;
                border-radius: 100%;
                text-align: center;
                line-height: 36px;
                color: #ffffff;
                font-size: 20px;
              "
            >
              <van-icon name="arrow-left" style="line-height: 36px" />
            </div>
          </div>
        </div>

        <div style="padding: 12px">
          <div class="detail-block">
            <div
                class="detail-title t-al-l"
                style="
                font-size: 18px;
                font-weight: bold;
                color: rgb(255, 120, 12);
              "
            >
              {{ detail.tit }}
            </div>
          </div>

          <div class="detail-block">
            <div
                class="detail-title t-al-l"
                style="font-size: 18px; padding: 12px 0"
            >
              商标信息
            </div>
          </div>

          <div class="detail-block">
            <div
                style="
                font-size: 14px;
                line-height: 30px;
                color: #959595;
                text-align: left;
              "
            >
              有效期限：{{ detail.valid_date }}<br />
              所属类别：{{ detail.classify }}类 - {{ detail.classify_name
              }}<br />

          




              类似群组：{{ detail.analogues_group }}<br />
              适用项目：{{ detail.fit_projects }}<br />


              <!--输出五行信息-->




            </div>

            
          </div>
        </div>
      </div>
    </van-popup>



  <van-popup position="top" class="product_detail" v-model="puton_show" >
      <div
          style="
          background-color: #ffffff;
          min-height: 80px;
          width: 100%;
          padding: 16px;
          box-sizing: border-box;
        "
      >
        <div
            style="
            position: relative;
            font-size: 0;
            border-bottom: 1px solid #f1f1f1;
          "
        >
          <div
              style="position: absolute; left: 16px; top: 16px"
              @click="goBack"
          >
            <div
                style="
                width: 36px;
                height: 36px;
                background: #7e7e7e;
                border-radius: 100%;
                text-align: center;
                line-height: 36px;
                color: #ffffff;
                font-size: 20px;
              "
            >
              <van-icon name="arrow-left" style="line-height: 36px" />
            </div>
          </div>



        <div style="padding-top: 54px;">
          <van-tabs v-for="(detail,index) in puton_list">
            <van-tab :title="'备案' + (index + 1)">



             <van-form>


                <van-field name="checkboxGroup" label="流水号">
                  <template #input>
                    {{detail.flow}}
                  </template>
                </van-field>





                <van-field name="checkboxGroup" label="商标个数">
                  <template #input>
                    {{detail.$commonreg_nos_info.length}}
                  </template>
                </van-field>


                <van-field name="checkboxGroup" label="商标">
                  <template #input>

                    <!-- TODO 优化商标显示 -->

                    <div v-for="item in detail.reg_nos_info" :key="item.reg_no">
                      <brand-item :reg_no="item.reg_no"></brand-item>
                    </div>
                  </template>
                </van-field>



                <van-field name="checkboxGroup" label="状态">
                  <template #input>
                    {{detail.status_text}}
                  </template>
                </van-field>



                <van-field name="checkboxGroup" label="备案价格">
                  <template #input>
                    {{detail.price}}
                  </template>
                </van-field>


                <!-- <van-field name="checkboxGroup" label="备注">
                  <template #input>
                    {{detail.puton_remark}}
                  </template>
                </van-field> -->


                <van-field name="checkboxGroup" label="销售">
                  <template #input>
                    {{detail.uname}}
                  </template>
                </van-field>


                <van-field name="checkboxGroup" label="开始时间">
                  <template #input>
                    {{detail.start_at}}
                  </template>
                </van-field>

                <van-field name="checkboxGroup" label="结束时间">
                  <template #input>
                    {{detail.end_at}}
                  </template>
                </van-field>


                 <van-field name="checkboxGroup" label="备注">
                  <template #input>
                    {{detail.puton_remark}}
                  </template>
                </van-field>


                <!-- <van-field name="checkboxGroup" label="联系人">
                  <template #input>
                    {{detail.contact_name}}
                  </template>
                </van-field>


                <van-field name="checkboxGroup" label="微信号">
                  <template #input>
                    {{detail.wechat}}
                  </template>
                </van-field> -->


                <van-field name="checkboxGroup" label="来源">
                  <template #input>
                    {{detail.source_type_text}}
                  </template>
                </van-field>

              </van-form>

            </van-tab>
          </van-tabs>
        </div>

        </div>
      </div>
    </van-popup>





    <van-popup v-model="reserved_info_show">
      <div style="padding: 24px;text-align: left;width: 320px;background-color: #f5f5f5;">
        <!--查看预留信息的表单-->

        <div style="font-size: 18px;font-weight: bold;margin-bottom: 12px;">预留信息</div>

        <div>
          <van-field
              :value="reserved_info.username"
              label="姓名"
          />
          <van-field
              :value="reserved_info.time1"
              label="预留时间"
          />
          <van-field
              :value="reserved_info.reserved_content"
              label="备注"
          />
        </div>

      </div>
    </van-popup>

    <!-- 商标类别选择弹出层 -->
    <van-popup 
      v-model="classifyPopupShow" 
      position="bottom" 
      :style="{ height: '90%' }"
      round
      closeable
    >
      <div style="height: 100%; display: flex; flex-direction: column;">
        <!-- 标题栏 -->
        <div style="padding: 16px; border-bottom: 1px solid #f1f1f1; flex-shrink: 0;">
          <div style="text-align: center; font-size: 16px; font-weight: bold;">商标类别列表</div>
        </div>


        <!-- 类别列表 - 三列网格布局 -->
        <div style="flex: 1; overflow-y: auto; padding: 12px;">
          <van-checkbox-group v-model="selectedClassifyIds" @change="onClassifyChange">
            <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px;">
              <div 
                v-for="item in classifyList" 
                :key="item.id"
                :class="{ 'classify-item-selected': selectedClassifyIds.includes(item.id) }"
                class="classify-item"
                @click="toggleClassifyItem(item.id)"
              >
                <van-checkbox 
                  :name="item.id" 
                  icon-size="14px"
                  style="margin-right: 4px; pointer-events: none;"
                ></van-checkbox>
                <span style="font-size: 12px; line-height: 1.3; pointer-events: none;">{{ item.id }}类 {{ item.name }}</span>
              </div>
            </div>
          </van-checkbox-group>
        </div>
        
        <!-- 底部按钮 -->
        <div style="padding: 16px; border-top: 1px solid #f1f1f1; flex-shrink: 0;">
          <div style="display: flex; gap: 12px;">
            <van-button 
              block 
              style="flex: 1;" 
              @click="resetClassifySelection"
            >
              重置
            </van-button>
            <van-button 
              block 
              type="primary" 
              style="flex: 1; background: #ee0a24;" 
              @click="selectAllClassify"
            >
              全选
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 搜索类型选择弹出层 -->
    <van-action-sheet
      v-model="searchTypePopupShow"
      :actions="searchTypeActions"
      @select="onSelectSearchType"
      cancel-text="取消"
      title="请选择要搜索的类型"
    />

    <van-popup
      v-model="share_show"
      round="true"
      position="bottom"
      :style="{ 'min-height': '10%' }"
    >
      <div>
        <div class="van-share-sheet__options">
          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="doCopy"
          >
            <img
              src="https://img01.yzcdn.cn/vant/share-sheet-link.png"
              class="van-share-sheet__icon"
            /><span class="van-share-sheet__name">复制链接</span>
          </div>
        </div>
        <button
          type="button"
          class="van-share-sheet__cancel"
          @click="doShareShowCancel"
        >
          取消
        </button>
      </div>
    </van-popup>

  </div>
</template>


<style>

.v-l-m{
  vertical-align: middle;
}

.van-cell-group--inset {
    margin: 0 0 !important;
}

.payment .search-wrapper .van-cell {
  border: 1px solid rgb(241, 241, 241);
  border-radius: 6px;
}


.van-toast--text{
  z-index: 9999999999 !important;
}

</style>

<style>

.green-item .real-box{
  border: 1px solid green !important;
}

.product_detail{
  z-index: 99999!important;
}

.cus_price_input {
  display: inline-block;
  width: 100%;
  line-height: 26px;
  box-sizing: border-box;
  padding: 0 14px;
  /*transform: translateY(-1px);*/
  border-radius: 4px;
  border: 1px solid #9c9c9c;
  font-size: 12px;
}

.inter .van-tabs__line {
  display: none;
}

.inter .van-tab--active img {
  border: 2px solid #ff0000;
  border-radius: 100%;
}

.inter .van-tab--active {
  color: #ff0000;
}

.inter .van-tabs--line .van-tabs__wrap {
  height: 76px !important;
}
.filter-title {
  padding-right: 4px;
  position: relative;
  background: #fff;
  font-size: 13px;
  margin-bottom: 10px;
  color: #333333;
  padding-left: 6px;
  font-weight: bold;
  text-align: left;
  line-height: 26px;
}

.filter-item {
  display: inline-block;
  width: 25%;
  padding: 0 6px;
  box-sizing: border-box;
  margin-bottom: 12px;
  text-align: center;
}

.filter-item span {
  background: #f5f5f5;
  color: #333;
  font-size: 12px;
  line-height: 30px;
  display: inline-block;
  width: 100%;
  border-radius: 4px;
}

.filter-item .active {
  border: 1px solid #fe001c;
  box-sizing: border-box;
  color: #fe001c;
  background: none;
}

.radio_item .active {
  border: 1px solid #1989fa !important;
  box-sizing: border-box;
  color: #1989fa !important;
  background: none;
}

.time-text {
  font-size: 0.4rem;
  color: #000000;
}

.price-text {
  font-size: 0.7rem;
  color: #000000;
}

.desc-text {
  font-size: 0.45rem;
  color: #222222;
  line-height: 0.675rem;
}

.van-sidebar {
  width: 100%;
}

/* 商标类别选择卡片样式 */
.classify-item {
  display: flex;
  align-items: center;
  padding: 4px 4px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  min-height: 22px;
}

.classify-item:hover {
  background: #f0f0f0;
  border-color: #1989fa;
}

.classify-item:active {
  transform: scale(0.98);
}

.classify-item-selected {
  background: #e7f4ff !important;
  border-color: #1989fa !important;
  color: #1989fa;
}


</style>
<script>
import common from "../assets/js/common";
import addone from "../components/addone";
import _ from "underscore";
import UpDown from "@/components/UpDown";
import InfiniteLoading from "vue-infinite-loading";
import { Base64 } from "js-base64";
import moment from "moment";
import { ImagePreview } from "vant"
import Fly from 'flyio/dist/npm/fly'
import stroe from '../store'
import BrandItem from '@/components/BrandItem.vue'


/**明天的日期对象**/
// let now = new Date()
// let startDate = now.toLocaleDateString().replace(/\//g, '-')
// let after = now.setDate(now.getDate() + 1)
// after = new Date(after)

// let five_after = now.setDate(now.getDate() + 4)
// five_after = new Date(five_after)

export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    },


    had_reserved_flag:function(newval){


      console.log('预留标识')
      console.log(newval)

      if( newval ){
        this.reserved_type = '2'
        this.time1 = this.five_after
      }else{
        this.reserved_type = '1'
        this.time1 = this.after
      }
    },


    reserved_type: function(newval){
      if( newval == '1' ){
        this.time1 = this.after
      }

      if( newval == '2' ){
        this.time1 = this.five_after
      }
    },

    pick_switch: function (value) {
      console.log("pick_switch变更");
      console.log(this.pick_switch);
    },


    selected_texts: function (value) {
      console.log("当前选中");
      if (_.where(this.classifyConfig, { selected: 1 }).length > 1) {
        //选中多个
        this.filter_data[1].list[0].checked = true;
      } else {
        //选中一个
        this.filter_data[1].list[0].checked = false;
      }
    },
    keyword: function (value) {
      // if( value ) {
      //   if( !this.filter_data[0].list[3].checked ) {
      //     this.chosenFilter(0, 3)
      //   }
      // }
    },


    quick_search_reg_no(newval)
    {
      console.log('变化的快速搜索')
      console.log(newval)

      //用js判断是不是正常的注册号, 8位数字，带A或者不带A, 默认去掉首尾空格
      if(!(/^[0-9]{8}A{0,1}$/.test(newval))) {
        console.log('请输入正确的注册号')
        this.it = false
        return;
      }else {
        this.quickSearch(newval)
      }
    },

    classifyConfig: {
      handler() {
        // 同步classifyConfig的选中状态到selectedClassifyIds
        this.selectedClassifyIds = this.classifyConfig
          .filter(item => item.selected === 1)
          .map(item => item.id);
      },
      deep: true,
      immediate: true
    },
    selectedClassifyIds: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          common.setTitle("商标类别：" + newVal.join(","));
        } else {
          common.setTitle("点我选商标");
        }
      },
      immediate: true
    }
  },
  components: {
    addone,
    UpDown,
    InfiniteLoading,
    BrandItem
  },
  data: function () {
    return {
      show: false,
      date_show: false,
      begin_price: "",
      end_price: "",
      begin_price_show: false,
      end_price_show: false,
      it: false,
      reserved_info: {
        username: "",
        time1: "",
        reserved_content: "",
      },

      product_show: false,

      reserved_type: '1',

      reserved_content: "",
      list_combine: [],
      active: 0,
      page: 1,

      pick_switch: false,
      pick_flag: false,
      pick_arr: [],


      source_type: '',

      delete_switch: false,
      delete_flag: false,
      delete_arr: [],

      chosen_classify_flag: false,
      quick_search_reg_no: '',

      reserved_flag: false,
      reserved_arr: [],

      puton_flag: false,
      puton_arr: [],

      reserved_show: false,
      reserved_info_show: false,

      is_five_phases: this.$common.isFive()?1:'',

      puton_show: false,


      puton_confirm_show: false,



      quick_search_flag: false,

      time1: moment().add('days', 1).format('YYYY-MM-DD'),

      filter_data: [
        {
          title: "商标归属",
          is_intern: 0,
          list: [
            { name: "不限", checked: false, type: -1 },
            { name: "自有", checked: true, type: 1 },
            { name: "一级", checked: true, type: 6 },
            // {name:'二级', checked:false, type: 7},
          ],
          hide: true
        },

        {
          title: "是否同名",
          is_intern: 0,
          list: [
            { name: "要求同名", checked: false, type: 1 },
          ],
        },

        {
          title: "是否预留",
          is_intern: 0,
          list: [
            { name: "不限", checked: true, type: -1 },
            { name: "是", checked: false, type: 1 },
            { name: "否", checked: false, type: 0 },
          ],
          hide: true
        },

        {
          title: "是否有效果图",
          is_intern: 0,
          list: [
            { name: "不限", checked: true, type: -1 },
            { name: "是", checked: false, type: 1 },
            { name: "否", checked: false, type: 0 },
          ],
          hide: true,
        },

        {
          title: "价格",
          is_intern: 0,
          list: [
            { name: "不限", checked: false, type: -1 },
            { name: "3001-6000", checked: true, type: 2 },
            { name: "6001-12000", checked: true, type: 50 },
            { name: "12001-2万", checked: false, type: 3 },
            { name: "2万-5万", checked: false, type: 4 },
            { name: "5万以上", checked: false, type: 5 },
            { name: "自定义", checked: false, type: 99 },
          ],
          hide: true,
        },

        {
          title: "字符",
          is_intern: 0,
          list: [
            { name: "不限", checked: true, type: -1 },
            { name: "1-2字", checked: false, type: 128 },
            { name: "3字", checked: false, type: 129 },
            { name: "4字", checked: false, type: 130 },
            { name: "5字", checked: false, type: 131 },
          ],
          hide: true,
        },
        {
          title: "注册年限",
          is_intern: 0,
          list: [
            { name: "不限", checked: true, type: -1 },
            { name: "一年以内", checked: false, type: 134 },
            { name: "一到两年", checked: false, type: 135 },
            { name: "两到三年", checked: false, type: 136 },
            { name: "三年以上", checked: false, type: 137 },
          ],
          hide: true
        },
        {
          title: "组合类型",
          is_intern: 0,
          list: [
            { name: "不限", checked: true, type: -1 },
            { name: "中文", checked: false, type: 139 },
            { name: "英文", checked: false, type: 140 },
            { name: "中+英", checked: false, type: 141 },
            { name: "图型", checked: false, type: 142 },
            { name: "中+图", checked: false, type: 143 },
            { name: "组合", checked: false, type: 144 },
            { name: "数字", checked: false, type: 145 },
            { name: "拼音", checked: false, type: 146 },
            { name: "英+图", checked: false, type: 147 },
            { name: "中+拼", checked: false, type: 148 },
            { name: "中英图", checked: false, type: 149 },
          ],
        },
        {
          title: "五行",
          is_intern: 0,
          list: [
            { name: "不限", checked: true, type: -1 },
            { name: "金", checked: false, type: 1 },
            { name: "木", checked: false, type: 2 },
            { name: "水", checked: false, type: 3 },
            { name: "火", checked: false, type: 4 },
            { name: "土", checked: false, type: 5 }
          ],
          hide: true
        },
        {
          title: "价格等级",
          is_intern: 0,
          list: [
            { name: "不限", checked: true, type: -1 },
            { name: "A", checked: false, type: 1 },
            { name: "B", checked: false, type: 2 },
            { name: "C", checked: false, type: 3 },
          ],
          hide: true
        },
        {
          title: "是否新商标",
          is_intern: 0,
          list: [
            { name: "不限", checked: true, type: -1 },
             { name: "是", checked: false, type: 1 },
            { name: "否", checked: false, type: 0 }
          ],
          hide: true,
        },
        {
          title: "是否全类",
          is_intern: 0,
          list: [
            { name: "不限", checked: false, type: -1 },
             { name: "是", checked: false, type: 1 },
            { name: "否", checked: true, type: 0 }
          ],
          hide: true
        }
      ],
      filter_data_tmp: [],
      list: [],
      classify_id: "",
      keyword: "",
      is_intern: "",
      classifyConfig: this.$common.classifyConfig(),
      activeKey: 0,
      subClassify: [],
      activeSubCode: "",
      isInit: true,
      sub_code: "",
      interList: [
      ],
      top: 0,
      title: "",

      rang_arr: [1, 0, 0, 1, 0],
      username: "",
      password: "",
      detail: {},
      oss_visit_config: false,
      puton_list: [],
      puton_price: '',
      puton_remark: '',
      add_puton_loading: false, 
      add_reserved_loading: false,
      after: '',
      five_after: moment().add('days', 5).format('YYYY-MM-DD'),
      totalCount: 0,
      share_show: false,
      needsInfiniteLoadReset: false,
      
      // 新增商标类别弹出层相关数据
      classifyPopupShow: false,
      selectedClassifyIds: [],

      // 搜索类型弹出层相关数据
      searchTypePopupShow: false,
      currentSearchType: { id: 1, name: '商标名称' },
      searchTypeActions: [
        { name: '商标名称', id: 1 },
        { name: '英文商标', id: 2 },
        { name: '注册号', id: 3 },
        { name: '商品小项', id: 4 },
        { name: '商品名称', id: 5 },
        // { name: '多类查找', id: 6 }
      ],
      classifyList: [
        { id: 1, name: '化工原料' },
        { id: 2, name: '颜料油漆' },
        { id: 3, name: '日化用品' },
        { id: 4, name: '燃料油脂' },
        { id: 5, name: '医药用品' },
        { id: 6, name: '金属材料' },
        { id: 7, name: '机械设备' },
        { id: 8, name: '手工器械' },
        { id: 9, name: '科学仪器' },
        { id: 10, name: '医疗器械' },
        { id: 11, name: '灯具空调' },
        { id: 12, name: '运输工具' },
        { id: 13, name: '烟火相关' },
        { id: 14, name: '珠宝钟表' },
        { id: 15, name: '乐器' },
        { id: 16, name: '办公用品' },
        { id: 17, name: '橡胶制品' },
        { id: 18, name: '皮革皮具' },
        { id: 19, name: '建筑材料' },
        { id: 20, name: '家具用品' },
        { id: 21, name: '厨房洁具' },
        { id: 22, name: '绳网袋蓬' },
        { id: 23, name: '纱线丝' },
        { id: 24, name: '布料床单' },
        { id: 25, name: '服装鞋帽' },
        { id: 26, name: '纽扣拉链' },
        { id: 27, name: '地毯席垫' },
        { id: 28, name: '健身器材' },
        { id: 29, name: '食品' },
        { id: 30, name: '方便食品' },
        { id: 31, name: '饲料种籽' },
        { id: 32, name: '啤酒饮料' },
        { id: 33, name: '酒精饮品' },
        { id: 34, name: '香烟烟具' },
        { id: 35, name: '广告销售' },
        { id: 36, name: '金融物管' },
        { id: 37, name: '建筑修理' },
        { id: 38, name: '通讯服务' },
        { id: 39, name: '运输贮藏' },
        { id: 40, name: '材料加工' },
        { id: 41, name: '教育娱乐' },
        { id: 42, name: '网站服务' },
        { id: 43, name: '餐饮住宿' },
        { id: 44, name: '医疗园艺' },
        { id: 45, name: '社会服务' }
      ]
    }
  },
  methods: {
    updateUrlQuery() {
      const query = {};

      if (this.keyword) {
        query.keyword = this.keyword;
      }

      if (this.currentSearchType && this.currentSearchType.id) {
        query.search_type = this.currentSearchType.id;
      }

      const selectedClassifyIds = this.classifyConfig
        .filter(item => item.selected === 1)
        .map(item => item.id);
      if (selectedClassifyIds.length > 0) {
        query.classify_ids = selectedClassifyIds.join(',');
      }

      if (this.is_intern) {
        query.is_intern = this.is_intern;
      }

      if (this.reg_no_like) {
        query.reg_no_like = this.reg_no_like;
      }

      if (this.begin_price) {
        query.begin_price = this.begin_price;
      }
      if (this.end_price) {
        query.end_price = this.end_price;
      }

      if (Object.keys(query).length > 0 && JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Router Error:', err);
          }
        });
      } else if (Object.keys(query).length === 0 && Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ query: {} }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Router Error:', err);
          }
        });
      }
    },
    applyQuery() {
      const query = this.$route.query;
      if (Object.keys(query).length === 0) {
        return;
      }

      localStorage.removeItem("EXPORT_SEARCH");

      let needsSearch = false;

      if (query.keyword) {
        this.keyword = decodeURIComponent(Base64.decode(query.keyword));
        needsSearch = true;
      }

      if (query.search_type) {
        const searchType = this.searchTypeActions.find(t => t.id == query.search_type);
        if (searchType) {
          this.currentSearchType = searchType;
          needsSearch = true;
        }
      }

      if (query.classify_ids) {
        const ids = query.classify_ids.split(',').map(id => parseInt(id, 10));
        this.selectedClassifyIds = ids;
        this.classifyConfig.forEach(item => {
            item.selected = ids.includes(item.id) ? 1 : 0;
        });
        needsSearch = true;
      }

      if (query.is_intern) {
        this.is_intern = query.is_intern;
        const interItem = this.interList.find(item => item.country_code == query.is_intern);
        if (interItem) {
            this.active = this.interList.indexOf(interItem);
        }
        needsSearch = true;
      }

      if (query.reg_no_like) {
        this.reg_no_like = query.reg_no_like;
        needsSearch = true;
      }

      if (query.begin_price) {
        this.begin_price = query.begin_price;
        needsSearch = true;
      }

      if (query.end_price) {
        this.end_price = query.end_price;
        needsSearch = true;
      }

      if (needsSearch) {
        this.page = 1;
        this.list = [];
        this.isInit = false;
        if (this.$refs.infiniteLoading) {
          this.$refs.infiniteLoading.stateChanger.reset();
        } else {
          this.needsInfiniteLoadReset = true;
        }
      }
    },
    doCopy() {
      //复制链接

      let text = location.href;

      var textareaEl = document.createElement("textarea");
      textareaEl.setAttribute("readonly", "readonly"); // 防止手机上弹出软键盘
      textareaEl.value = text;
      document.body.appendChild(textareaEl);
      textareaEl.select();
      var res = document.execCommand("copy");
      document.body.removeChild(textareaEl);
      console.log("复制成功");
      this.share_show = false;
      // return res
      common.mAlert(this, "复制成功");
    },

    doShareShow() {
      console.log("点击分享");
      this.share_show = true;
    },
    doShareShowCancel() {
      this.share_show = false;
    },

    // 商标类别选择相关方法
    showClassifyPopup() {
      this.classifyPopupShow = true;
    },
    
    onClassifyChange() {
      // 直接联动，实时更新搜索结果
      this.classifyConfig.forEach(item => {
        item.selected = this.selectedClassifyIds.includes(item.id) ? 1 : 0;
      });
      // this.triggerSearch();
    },
    
    resetClassifySelection() {
      this.selectedClassifyIds = [];
      this.onClassifyChange();
    },
    
    selectAllClassify() {
      this.selectedClassifyIds = this.classifyList.map(item => item.id);
      this.onClassifyChange();
    },

    toggleClassifyItem(id) {
      const index = this.selectedClassifyIds.indexOf(id);
      if (index > -1) {
        this.selectedClassifyIds.splice(index, 1);
      } else {
        this.selectedClassifyIds.push(id);
      }
      this.onClassifyChange();
    },

    // 搜索类型相关方法
    showSearchTypePopup() {
      this.searchTypePopupShow = true;
    },

    onSelectSearchType(action) {
      this.currentSearchType = { id: action.id, name: action.name };
      this.searchTypePopupShow = false;
      // 这里可以添加搜索类型变更后的联动逻辑
      console.log('选择的搜索类型:', this.currentSearchType);
    },



    showPutonInfo(item){
      //展示备案信息
      console.log('展示备案信息')
      console.log(item)

      this.puton_list = [] 

      // this.puton_detail = item;
      this.puton_show = true

      this.puton_list = [] 


      new Fly().get(this.$common.dynamicHost()  + '/boot/customer.php?action=brand_puton_list',{id: item.id}).then((res)=>{
        res = JSON.parse(res.data)

        if( res.status )
        {





          let puton_list = res.data

          for( let i = 0, j = puton_list.length; i < j; i++){
            puton_list[i].reg_nos_info = JSON.parse(puton_list[i].reg_nos_info)
          }


          this.puton_list = puton_list

          console.log('备案详情')
          console.log(this.puton_list)

          // this.detail = res.data
          // console.log('reg_no detail:')
          // console.log(this.detail)

        }else{

        }
        // this.template_list = res.data
      }).catch((err)=>{

      })


    },


    onConfirm(value){
      this.date_show = false
      let date_str = moment(value).format('YYYY-MM-DD')
      
      
      this.time1 = date_str

      console.log(this.time1)
      // show.value = false;
      // date.value = formatDate(value);
    },

    searchRegNo()
    {
      if( !this.it )
      {
        // this.$Message.error('请输入正确的注册号');
        this.$common.mAlert(this, '请输入正确的注册号')
        return
      }

      localStorage.setItem("EXPORT_SEARCH", JSON.stringify({reg_no: this.it.reg_no}));
      this.$router.push({ path: "/invoice" });
      // window.parent.location.href = '/yjadmin1/product_export.php?reg_no=' + this.quick_search_item.reg_no


    },

    quick_search_reg_no(newval)
    {
      console.log('变化的快速搜索')
      console.log(newval)

      //用js判断是不是正常的注册号, 8位数字，带A或者不带A, 默认去掉首尾空格
      if(!(/^[0-9]{8}A{0,1}$/.test(newval))) {
        console.log('请输入正确的注册号')
        this.quick_search_item = false
        return;
      }else {
        this.quickSearch(newval)
      }
    },

    quickSearch(newval)
    {
      console.log('快搜地址')

      common.commonHttp('/product_segment/index_download.php?search=1&pageNo=1&pageSize=10&reg_no=' + newval, {}).then((res) => {

        // console.log('搜索结果')
        // console.log(res)
        //
        res = res.data;
        res = res.data.result[0]
        if( res.reg_no )
        {
          this.it = res
          console.log('搜索结果')
          console.log(this.quick_search_item)
        }else{

        }


        // this.subClassify = res.data.sub_classify;
      });


     
    },

    doQuickSearch()
    {
      this.quick_search_flag = true
    },


    previewImg(path) {
      ImagePreview([this.$common.polishingImg(path)]);
    },

    inputBeginPrice() {
      // alert(445)
      this.begin_price_show = true;
    },

    inputEndPrice() {
      this.end_price_show = true;
    },

    classifyUnSelected(item) {
      item.selected = false;
    },
    showChosenClassify() {
      this.chosen_classify_flag = true;
    },

    visitPath(path) {
      //访问配置
      if (!path || !this.oss_visit_config) {
        return "";
      }

      if (path.indexOf(this.oss_visit_config.trademark_prefix) !== -1) {
        return this.oss_visit_config.domain + path;
      } else {
        return path;
      }
    },

    goExport() {
      //导出

      //存入localstorage
      localStorage.setItem("EXPORT_SEARCH", JSON.stringify(this.getParams()));
      this.$router.push({ path: "/invoice" });
    },

    getParams() {
      let params = {
        pick_switch: this.pick_switch,
        delete_switch: this.delete_switch,
      };

      params.search_type = this.currentSearchType.id;
      if (this.keyword) {
        params.search_keyword = Base64.encode(encodeURIComponent(this.keyword));
      }


      if (this.reg_no_like) {
        params.reg_no_like = this.reg_no_like
      }


      //同名筛选

      params.rang_arr = JSON.stringify(this.rang_arr);

      //类别筛选

      //TODOO

      let classify_arr = [];

      let target = _.where(this.classifyConfig, { selected: 1 });

      if (target.length) {
        params.classify_arr = JSON.stringify(_.pluck(target, "type2id"));

        let classify_arr_group = [];
        for (let i = 0, j = target.length; i < j; i++) {
          console.log("目标");
          console.log(target[i]);

          let item = { ty2id: target[i].type2id, group: "", project: "" };

          //替换空格和中文的逗号
          let group_keyword = target[i].like_groups;
          if (group_keyword) {
            group_keyword = group_keyword.replace("/，/", ",");
            group_keyword = group_keyword.replace("/ /", "");

            //分隔内容,验证内容
            if (!/^[0-9,]+$/.test(group_keyword)) {
              alert("商标群组关键字不符合要求");
              return;
            }

            // classify_arr_group.push({ty2id: target[i].type, group:group_keyword})
            item.group = group_keyword;
          }

          let project_keyword = target[i].like_fits;
          if (project_keyword) {
            project_keyword = project_keyword.replace("/，/", ",");
            project_keyword = project_keyword.replace("/ /", "");

            //分隔内容,验证内容
            // if(!(/^[0-9,]+$/.test(group_keyword))) {
            //     alert('商标群组关键字不符合要求');
            //     return;
            // }

            // classify_arr_group.push({ty2id: target[i].type, group:group_keyword})
            item.project = Base64.encode(encodeURIComponent(project_keyword));
          }

          //处理project的关键字
          classify_arr_group.push(item);
        }

        console.log("最后的筛选值");
        console.log(classify_arr_group);

        //过滤群组关键字和使用项目关键字
        params.classify_arr_group = Base64.encode(
          JSON.stringify(classify_arr_group)
        );
      }

      //如果开启了过滤，需要GET和POST两种方式
      if (params.pick_switch) {
        //this.pick_arr

        params.pick_arr_reg_no = JSON.stringify(this.pick_arr);
      }

      if (params.delete_switch) {
        //this.pick_arr

        params.delete_arr_reg_no = JSON.stringify(this.delete_arr);
      }

      //是否同名

      // console.log('是否同名判断')
      // console.log(this.filter_data[1].list)
      target = _.where(this.filter_data[1].list, { checked: true });
      if (target.length) {
        params.same_name_flag = target[0].type == 1 ? 1 : 0;
      }

      //是否自有
      // target = _.where(this.filter_data[0].list, { checked: true });
      // if (target.length) {
      //   params.self_have_arr = JSON.stringify(_.pluck(target, "type"));
      // }

      //是否预留
      target = _.where(this.filter_data[2].list, { checked: true });
      if (target.length) {
        params.reserved_arr = JSON.stringify(_.pluck(target, "type"));
      }

      //是否有效果图
      target = _.where(this.filter_data[3].list, { checked: true });
      if (target.length) {
        params.effect = JSON.stringify(_.pluck(target, "type"));
      }

      //价格筛选
      // console.log('价格战')
      // console.log(this.filter_data[4].list)
      // target = _.where(this.filter_data[4].list, { checked: true });
      // if (target.length) {
      //   params.price_arr = JSON.stringify(_.pluck(target, "type"));
      // }

      // params.begin_price = this.begin_price;
      // params.end_price = this.end_price;

      //字符筛选
      target = _.where(this.filter_data[5].list, { checked: true });
      if (target.length) {
        params.char_arr = JSON.stringify(_.pluck(target, "type"));
      }

      //注册年限
      target = _.where(this.filter_data[6].list, { checked: true });
      if (target.length) {
        params.year_arr = JSON.stringify(_.pluck(target, "type"));
      }

      //组合类型 combine_arr
      target = _.where(this.filter_data[7].list, { checked: true });
      if (target.length) {
        params.combine_arr = JSON.stringify(_.pluck(target, "type"));
      }

      if( this.is_five_phases )
      {


        //五行筛选
        target = _.where(this.filter_data[8].list, { checked: true });
        if (target.length) {
          params.five_phases_arr = JSON.stringify(_.pluck(target, "type"));
        }


        //价格等级
        target = _.where(this.filter_data[9].list, { checked: true });
        if (target.length) {
          params.price_level_arr = JSON.stringify(_.pluck(target, "type"));
        }
        




        params.is_five_phases = 1
      }

      //是否新商标
      //是否预留
      target = _.where(this.filter_data[10].list, { checked: true });
      if (target.length) {
        params.is_new = JSON.stringify(_.pluck(target, "type"));
      }


      //价格等级
      target = _.where(this.filter_data[11].list, { checked: true });
      if (target.length) {
        params.full_type_arr = JSON.stringify(_.pluck(target, "type"));
      }

      return params;
    },

    showReservedInfo(record) {

      console.log('预留信息查看')
      console.log(record)


      this.reserved_info.time1 = record.reserved_time
      this.reserved_info.username = record.reserved_name
      this.reserved_info.reserved_content = record.reserved_content

      console.log()



      this.reserved_info_show = true;
    },

    onPutonSubmit(){
      //TODO 备案提交


      //备案价格，备案来源需要填写
      if( !this.puton_price ){
        this.$common.mAlert(this,'请填写备案价格')
        return
      }

      if( !this.source_type ){
        this.$common.mAlert(this, '请选择来源')
        return
      }


      if( !this.puton_arr.length ){
        this.$common.mAlert(this, '商标不能为空')
        return
      }

      new Fly().post(this.$common.dynamicHost()  + '/boot/customer.php?action=add_or_modify_puton', Object.assign({
          source_type: this.source_type,
          price: this.puton_price,
          puton_remark: this.puton_remark,
           admin_id: this.$common.getAuth()
      }, {
          reg_nos: JSON.stringify(_.pluck(this.puton_arr, 'reg_no')),
          reg_nos_info: JSON.stringify(this.puton_arr)
      })).then((res) => {
          res = JSON.parse(res.data)
          if (res.status) {
              // this.edit_flag = false
              // this.$refs.table.forceReload()
              // localStorage.removeItem('PUTON_ARR')
              location.reload()
          } else {
              // this.edit_flag = false
              // this.$refs.table.forceReload()
              this.$Message.error(res.desc);
          }
      })
    },

    onSubmit() {
      // alert('提交商标预留')

      let checked_reg_nos = [];
      let target = this.reserved_arr;
      if (target.length) {
        checked_reg_nos = _.pluck(target, "reg_no");
      }

      console.log("预留");
      console.log(target);
      console.log(checked_reg_nos);

      common
        .commonHttp("/boot/product.php?action=reserved", {
          checked: JSON.stringify(checked_reg_nos),
          reserved_name: this.username,
          reserved_content: this.reserved_content,
          admin_id: this.admin_id,
          time: this.time1,
        })
        .then((res) => {
          this.$common.mAlert(this, "预留成功");
          this.reserved_show = false;
          this.reserved_arr = [];
          this.setTmpFilterData();
        });
    },

    confirmReserved() {
      //确认预留信息填写
      // this.reserved_show = true
      // this.show = false

      let checked_reg_nos = [];
      let target = this.reserved_arr;
      if (target.length) {
        checked_reg_nos = _.pluck(target, "reg_no");
      }


      if( !checked_reg_nos.length ){
        this.$common.mAlert(this, '需要至少选择一个商标')
        return
      }

      this.add_reserved_loading = true

      console.log("预留");
      console.log(target);
      console.log(checked_reg_nos);

      common
        .commonHttp("/boot/product.php?action=reserved", {
          checked: JSON.stringify(checked_reg_nos),
          reserved_name: this.username,
          reserved_content: this.reserved_content,
          reserved_type: this.reserved_type,
          admin_id: this.$common.getAuth(),
          time: this.time1,
        })
        .then((res) => {
          this.$common.mAlert(this, "预留成功");
          this.reserved_show = false;
          this.reserved_arr = []
          this.add_reserved_loading = false
          this.setTmpFilterData();
        });

    },

    confirmPuton(){



      

      //TODO 备案设置
      if (!this.source_type) {
            this.$common.mAlert(this, '来源必须选择');
            return
        }


        if (!this.puton_arr.length ) {
            this.$common.mAlert(this, '至少选择一个商标');
            return
        }


        if( this.add_puton_loading ){
          return
        }


        this.add_puton_loading = true


        //添加备案
        let reg_nos_info = []
        for( let i = 0 , j = this.puton_arr.length; i < j; i++ )
        {
            reg_nos_info.push(
                {
                    reg_no: this.puton_arr[i].reg_no,
                    tit: this.puton_arr[i].tit,
                    ty2id: this.puton_arr[i].ty2id,
                    price: this.puton_arr[i].sum_indus_price_saleoff
                }
            )
        }


        new Fly().post(this.$common.dynamicHost()  + '/boot/customer.php?action=add_or_modify_puton', Object.assign({
            source_type: this.source_type,
            price: this.puton_price,
            puton_remark: this.puton_remark,
            admin_id: this.$common.getAuth()

        }, {
            reg_nos: JSON.stringify(_.pluck(this.puton_arr, 'reg_no')),
            reg_nos_info: JSON.stringify(reg_nos_info)
        })).then((res) => {
            res = JSON.parse(res.data)
            if (res.status) {
                // this.edit_flag = false
                // this.$refs.table.forceReload()

                this.add_puton_loading = false
                localStorage.removeItem('PUTON_ARR')

                location.reload()
            } else {
                // this.edit_flag = false
                // this.$refs.table.forceReload()
                this.add_puton_loading = false
                this.$Message.error(res.desc);
            }
        })



      // //设置puton_price的价格
      // this.puton_price = this.calc_puton_price
      // this.puton_remark = ''
      // this.source_type = ''
      

      // this.puton_confirm_show = true
      // this.show = false
    },

    setRang(ind) {
      if (ind == 0) {
        this.rang_arr[1] = 0;
        this.rang_arr[2] = 0;
        this.rang_arr[3] = 0;
        this.rang_arr[0] = 2;
        this.rang_arr[4] = 0;
      }

      if (ind == 1) {
        this.rang_arr[0] = 1;
        this.rang_arr[2] = 0;
        this.rang_arr[3] = 0;
        this.rang_arr[4] = 0;

        if (this.rang_arr[1] == 2) {
          this.rang_arr[1] = 1;
        } else {
          this.rang_arr[1] += 1;
        }

        console.log(this.rang_arr);
      }

      // alert(33)
      if (ind == 2) {
        this.rang_arr[0] = 1;
        this.rang_arr[1] = 0;
        this.rang_arr[3] = 0;
        this.rang_arr[4] = 0;

        if (this.rang_arr[2] == 2) {
          this.rang_arr[2] = 1;
        } else {
          this.rang_arr[2] += 1;
        }

        // console.log(this.rang_arr)
      }

      if (ind == 3) {
        this.rang_arr[0] = 1;
        this.rang_arr[1] = 0;
        this.rang_arr[2] = 0;
        this.rang_arr[4] = 0;

        if (this.rang_arr[3] == 2) {
          this.rang_arr[3] = 1;
        } else {
          this.rang_arr[3] += 1;
        }

        // console.log(this.rang_arr)
      }

      if (ind == 4) {
        this.rang_arr[0] = 1;
        this.rang_arr[1] = 0;
        this.rang_arr[2] = 0;
        this.rang_arr[3] = 0;

        if (this.rang_arr[4] == 2) {
          this.rang_arr[4] = 1;
        } else {
          this.rang_arr[4] += 1;
        }

        // console.log(this.rang_arr)
      }

      this.$forceUpdate();

      this.setTmpFilterData();

      //页面刷新
      // this.onSearch()
    },

    setChosen(record) {
      if (this.delete_flag) {
        if (this.isDeleted(record.id)) {
          //移除

          for (let i = 0, j = this.delete_arr.length; i < j; i++) {
            if (this.delete_arr[i].id == record.id) {
              this.delete_arr.splice(i, 1);
              break;
            }
          }
        } else {
          this.delete_arr.push({
            id: record.id,
            tit: record.tit,
            reg_no: record.reg_no,
          });
          console.log("当前删除选中");
          console.log(this.delete_arr);
        }
      }

      if (this.pick_flag) {
        if (this.isPicked(record.id)) {
          //移除

          for (let i = 0, j = this.pick_arr.length; i < j; i++) {
            if (this.pick_arr[i].id == record.id) {
              this.pick_arr.splice(i, 1);
              break;
            }
          }
        } else {
          this.pick_arr.push({
            id: record.id,
            tit: record.tit,
            reg_no: record.reg_no,
          });
          console.log("当前选中");
          console.log(this.pick_arr);
        }
      }

      if (this.reserved_flag) {


        //TODO 避免重复预留的提示，如果是管理员那么可以预留
        if( record.is_reserved && !this.$common.isSuperAdmin() ){
          this.$common.mAlert(this, '该商标已被预留')
          return
        }



        if (this.isReserved(record.id)) {
          //移除

          for (let i = 0, j = this.reserved_arr.length; i < j; i++) {
            if (this.reserved_arr[i].id == record.id) {
              this.reserved_arr.splice(i, 1);
              break;
            }
          }
        } else {
          this.reserved_arr.push({
            id: record.id,
            tit: record.tit,
            reg_no: record.reg_no,
            cover_img: record.cover_img,
            ty2id: record.ty2id,
            is_reserved: record.is_reserved
          });
          console.log("当前选中");
          console.log(this.reserved_arr);
        }
      }

      if( this.puton_flag ){
        this.puton_arr.push({
          id: record.id,
          tit: record.tit,
          reg_no: record.reg_no, 
          sum_indus_price: record.sum_indus_price,
          ty2id: record.ty2id,
          sum_indus_price_saleoff: record.sum_indus_price * 0.9,
          cover_img: record.cover_img
        })
      }
    },

    isPicked(id) {
      let ids = _.pluck(this.pick_arr, "id");
      if (ids.indexOf(id) !== -1) {
        return true;
      }

      return false;
    },

    isDeleted(id) {
      let ids = _.pluck(this.delete_arr, "id");
      if (ids.indexOf(id) !== -1) {
        return true;
      }

      return false;
    },

    isReserved(id) {
      let ids = _.pluck(this.reserved_arr, "id");
      if (ids.indexOf(id) !== -1) {
        return true;
      }

      return false;
    },

    isPuton(id){
      let ids = _.pluck(this.puton_arr, "id");
      if (ids.indexOf(id) !== -1) {
        return true;
      }

      return false;
    },

    activeChange() {
      this.chosenFilter(0, this.active);

      //然后搜索
      this.$nextTick(() => {
        this.setTmpFilterData();
      });
    },
    setActiveSubCode(code) {
      this.activeSubCode = code;
    },

    triggerSearch() {
      //把当前的分类带过去

      //设置当前分类
      // this.$store.commit('setSearchShow',1)'

      //TODO 当前搜索
      this.setTmpFilterData();
    },
    goBack() {
      this.product_show = false
      this.puton_show = false
    },
    resetFilterData() {
      location.reload();
    },
    infiniteHandler($state) {
      var params = {
        page: this.page,
        pageSize: 12,
        search_type: this.currentSearchType.id,
      };

      if (this.keyword) {
        params.keyword = this.keyword;
      }

      var selectedIds = this.classifyConfig
        .filter(function(item) { return item.selected === 1; })
        .map(function(item) { return item.id; });
      if (selectedIds.length > 0) {
        params.category = selectedIds.join(',');
      }

      common
        .commonHttp("/api/saas_api.php?action=list", params)
        .then(function(res) {
          var data = res.data;
          if (data.status === 1 && data.data.list.length) {
            this.page += 1;
            this.totalCount = data.data.totalCount;
            this.list.push.apply(this.list, data.data.list);
            $state.loaded();
          } else {
            $state.complete();
          }
        }.bind(this));
    },
    chosenFilter(index, ind) {
      //把所有的置为false
      // for( let i = 0, j = this.filter_data[index].list.length; i < j; i++ )
      // {
      //   this.filter_data[index].list[i].checked = false
      // }
      //
      // this.filter_data[index].list[ind].checked = true
      // if( this.filter_data[index].title == '商标归属')
      // {
      //
      //   for( let i = 0, j = this.filter_data[index].list.length; i < j; i++ )
      //   {
      //     this.filter_data[index].list[i].checked = false
      //   }
      //
      //   this.filter_data[index].list[ind].checked = true
      //   return
      // }

      if (this.filter_data[index].list[ind].type == -1) {
        for (let i = 1, j = this.filter_data[index].list.length; i < j; i++) {
          this.filter_data[index].list[i].checked = false;
        }
        this.filter_data[index].list[0].checked = true;
      } else {
        this.filter_data[index].list[ind].checked = this.filter_data[index]
          .list[ind].checked
          ? false
          : true;

        //重新设置不限

        let hasChecked = false;
        for (let i = 1, j = this.filter_data[index].list.length; i < j; i++) {
          if (this.filter_data[index].list[i].checked) {
            hasChecked = true;
            break;
          }
        }

        console.log(hasChecked);

        if (this.filter_data[index].list[0].type == -1) {
          this.filter_data[index].list[0].checked = hasChecked ? false : true;
        }
      }
    },
    setTmpFilterData() {
      this.show = false;
      this.filter_data_tmp = this.filter_data;
      this.list = [];
      this.page = 1;

      this.updateUrlQuery();

      //如果是国际标，设置active

      this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
    },
    filterMask() {
      this.show = true


      //设置预留时间

      // this.reserved_type = this.reserved_type
      // this.time1 = this.five_after

    },
    initPage: function () {},
    goDetail(item) {
      // return;
      //   this.$router.push({ path: '/brand_detail', query: { id: item.id }})
      this.detail = item;
      this.product_show = true;
    },

    upDownClick(ind) {
      if (ind != 1) {
        this.$refs.up_down_synth.clearIndex();
      }

      if (ind != 2) {
        this.$refs.up_down_new.clearIndex();
      }

      if (ind != 3) {
        this.$refs.up_down_popu.clearIndex();
      }

      if (ind != 4) {
        this.$refs.up_down_price.clearIndex();
      }

      //触发搜素
      this.page = 1;
      this.list = [];
      this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
    },
    searchChange() {
      //触发搜索变化
    },
  },
  created: function () {
    /**
     * 路由守卫已处理认证
     */

    // common.setTitle("查商标"); // Replaced by selectedClassifyIds watcher

    // common.setTitle("点我选商标");


    let after = moment().add('days', 1)
    if( after.day() == 0 ){
      after = after.add('days', 1)
    } else if( after.day() == 6 ){
      after = after.add('days', 2)
    }

    this.after = after.format('YYYY-MM-DD')
    this.time1 = this.after

    this.applyQuery();
  },
  mounted() {
    // console.log("设置tarbar")
    this.$store.commit('setTarbarShow',2)
    stroe.commit('setTarbarIndex',0)

    this.top = 92 ;
    // this.$emit("commitTarbar", 1)
    // stroe.commit('setTarbarIndex',1)
    //
    common.cusHttp(this, "/boot/mobile.php", {}, "get").then((res) => {
      res = JSON.parse(res.data);
      this.subClassify = res.data.sub_classify;
    });

    //阿里云OSS 访问配置
    common
      .cusHttp(this, "/boot/product.php?action=oss_visit_config", {}, "get")
      .then((res) => {
        res = JSON.parse(res.data);
        this.oss_visit_config = res.data;
      });

    this.classify_id = this.$route.query.classify_id;
    this.activeSubCode = this.$route.query.sub_code;
    this.sub_code = this.$route.query.sub_code;
    this.is_intern = this.$route.query.is_intern;
    if (!(this.is_intern == 1)) {
      this.is_intern = 0;
      this.top = 186;
      this.title = "商标查询和导出";
    } else {
      this.top = 262;
      this.title = "商标查询和导出";
    }
    this.keyword = this.$route.query.keyword;
    // this.$store.commit("setTarbarIndex", 0);

    //如果有 EXPORT_SEARCH, 那么恢复现场
    if (Object.keys(this.$route.query).length === 0 && localStorage.getItem("EXPORT_SEARCH")) {
      let search_params = JSON.parse(localStorage.getItem("EXPORT_SEARCH"));
      localStorage.removeItem('EXPORT_SEARCH')
      console.log("EXPORT_SEARCH的值");
      console.log(search_params);

      //类别筛选
      if (search_params.classify_arr) {
        let classify_arr = JSON.parse(search_params.classify_arr);
        for (let i = 0, j = classify_arr.length; i < j; i++) {
          let target = _.where(this.classifyConfig, {
            type2id: classify_arr[i],
          })[0];
          target.selected = 1;
        }

        let classify_arr_group = JSON.parse(
          Base64.decode(search_params.classify_arr_group)
        );

        console.log("类似群组搜索");
        console.log(classify_arr_group);

        for (let i = 0, j = classify_arr_group.length; i < j; i++) {
          let target = _.where(this.classifyConfig, {
            type2id: classify_arr_group[i].ty2id,
          })[0];
          target.like_groups = classify_arr_group[i].group;
          target.like_fits = classify_arr_group[i].project;
        }
      }

      if (search_params.pick_arr_reg_no) {
        this.pick_arr = JSON.parse(search_params.pick_arr_reg_no);
      }

      this.pick_switch = search_params.pick_switch;

      if (search_params.delete_arr_reg_no) {
        this.delete_arr = JSON.parse(search_params.delete_arr_reg_no);
      }

      this.delete_switch = search_params.delete_switch;

      //关键字搜索
      try {
        this.keyword = decodeURIComponent(Base64.decode(search_params.keyword));
      } catch (e) {
        console.log("沒有关键字");
      }

      //商标归属筛选
      if (search_params.self_have_arr) {
        let self_have_arr = JSON.parse(search_params.self_have_arr);
        this.filter_data[0].list[0].checked = false;
        this.filter_data[0].list[1].checked = false;
        this.filter_data[0].list[2].checked = false;
        for (let i = 0, j = self_have_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[0].list, {
            type: self_have_arr[i],
          })[0];
          console.log(target);
          target.checked = true;
        }
      }


      // //是否同名筛选
      if (search_params.same_name_flag) {
        console.log('是同名')
        this.filter_data[1].list[0].checked = 1
        console.log(this.filter_data[1])
      }


      //预留筛选
      if (search_params.reserved_arr) {
        let reserved_arr = JSON.parse(search_params.reserved_arr);
        this.filter_data[2].list[0].checked = false;
        for (let i = 0, j = reserved_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[2].list, {
            type: reserved_arr[i],
          })[0];
          console.log(target);
          target.checked = true;
        }
      }

      //效果图筛选
      if (search_params.effect) {
        let effect_arr = JSON.parse(search_params.effect);
        this.filter_data[3].list[0].checked = false;
        for (let i = 0, j = effect_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[3].list, {
            type: effect_arr[i],
          })[0];
          console.log(target);
          target.checked = true;
        }
      }


      //价格筛选
      if (search_params.price_arr) {
        let price_arr = JSON.parse(search_params.price_arr);
        this.filter_data[4].list[0].checked = false;
        this.filter_data[4].list[1].checked = false;
        this.filter_data[4].list[2].checked = false;
        for (let i = 0, j = price_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[4].list, {
            type: price_arr[i],
          })[0];
          target.checked = true;
        }
      }

      if(search_params.begin_price)
      { 
        this.begin_price = search_params.begin_price
      }

      if(search_params.end_price)
      { 
        this.end_price = search_params.end_price
      }


      //字符长度筛选
      if (search_params.char_arr) {
        let char_arr = JSON.parse(search_params.char_arr);
        this.filter_data[5].list[0].checked = false;
        for (let i = 0, j = char_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[5].list, {
            type: char_arr[i],
          })[0];
          console.log(target);
          target.checked = true;
        }
      }

      //注册年限筛选
      if (search_params.year_arr) {
        let year_arr = JSON.parse(search_params.year_arr);
        this.filter_data[6].list[0].checked = false;
        for (let i = 0, j = year_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[6].list, {
            type: year_arr[i],
          })[0];
          console.log(target);
          target.checked = true;
        }
      }

      //组合类型筛选
      if (search_params.combine_arr) {
        let combine_arr = JSON.parse(search_params.combine_arr);
        this.filter_data[7].list[0].checked = false;
        for (let i = 0, j = combine_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[7].list, {
            type: combine_arr[i],
          })[0];
          target.checked = true;
        }
      }


      //组合类型筛选
      if (search_params.five_phases_arr) {
        let combine_arr = JSON.parse(search_params.five_phases_arr);
        this.filter_data[8].list[0].checked = false;
        for (let i = 0, j = combine_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[8].list, {
            type: combine_arr[i],
          })[0];
          target.checked = true;
        }
      }


      //价格等级筛选
      if (search_params.price_level_arr) {
        let combine_arr = JSON.parse(search_params.price_level_arr);
        this.filter_data[9].list[0].checked = false;
        for (let i = 0, j = combine_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[9].list, {
            type: combine_arr[i],
          })[0];
          target.checked = true;
        }
      }


      //是否新标筛选
      if (search_params.is_new) {
        let combine_arr = JSON.parse(search_params.is_new);
        this.filter_data[10].list[0].checked = false;
        for (let i = 0, j = combine_arr.length; i < j; i++) {
          let target = _.where(this.filter_data[10].list, {
            type: combine_arr[i],
          })[0];
          target.checked = true;
        }
      }

      //排序筛选
      this.rang_arr = JSON.parse(search_params.rang_arr);

      this.initPage();
      // localStorage.removeItem('EXPORT_SEARCH')
    } else {
      this.initPage();
    }

    if (this.needsInfiniteLoadReset) {
      this.$refs.infiniteLoading.stateChanger.reset();
      this.needsInfiniteLoadReset = false;
    }
  },
  onShow() {
  
  },
  computed: {
    keywordPlaceholder() {
      switch (this.currentSearchType.id) {
        case 4: // 商品小项
          return '0203,0405,0608...';
        default:
          return '请输入关键词';
      }
    },

    had_reserved_flag:function(){
      let had_reserved_flag = false

      let target = this.reserved_arr
      // 
      for(let i = 0, j = target.length; i < j; i++){
          if( target[i].is_reserved == 1 ){
              had_reserved_flag = true
              break
          }
      }
      return had_reserved_flag
    },


    calc_puton_price:function(){
      let price = 0
      for( let i = 0, j = this.puton_arr.length; i < j; i++ ){
          price += parseInt(this.puton_arr[i].sum_indus_price)
      }

      return (price * 0.9).toFixed(0)
    },

    pick_arr_tits: function () {
      let tits = _.pluck(this.pick_arr, "tit");
      return tits.join(",");
    },

    // selected_classifies:  function()
    // {
    //   let target = _.where(this.classifyConfig, {selected: 1})
    //
    //   if( target.length )
    //   {
    //     let res_text_arr = []
    //     for( let i = 0, j = target.length; i < j; i++ )
    //     {
    //       res_text_arr.push(this.$common.paddingZero(target[i].id) +  '类-' + target[i].name)
    //     }
    //
    //     return res_text_arr.join('，')
    //   }else{
    //     return '全部'
    //   }
    // },

    selected_texts: function () {
      let target = _.where(this.classifyConfig, { selected: 1 });

      if (target.length) {
        let res_text_arr = [];
        for (let i = 0, j = target.length; i < j; i++) {
          res_text_arr.push(
            this.$common.paddingZero(target[i].id) + "类-" + target[i].name
          );
        }

        return res_text_arr.join("，");
      } else {
        return "全部";
      }
    },

    hotProducts: function () {
      console.log("次数");
      if (this.isInit && this.activeSubCode) {
      } else {
        this.activeSubCode = "全部";
      }
      // console.log('次数')

      let target = _.where(this.subClassify, {
        xh: this.search_classify_id + 1,
      });
      if (!target.length) {
        return [];
      }
      target = target[0];

      // let res_arr = [{code: '全部', checked: false}]

      return target.list;
    },
    currentListCombine: function () {
      var _self = this;
      var subList = _.filter(this.list_combine, function (item) {
        if (_self.active == 0) {
          return true;
        }

        if (_self.active == item.status) {
          return true;
        }
        return false;
      });
      console.log("合并列表");
      console.log(subList);
      return subList;
    },
    keywordTitle() {
      if (this.keyword) {
        return "-" + this.keyword;
      } else {
        return "";
      }
    },

    // 新增的计算属性
    isAllSelected() {
      return this.selectedClassifyIds.length === this.classifyList.length;
    },

    selected_classify_texts() {
      if (this.selectedClassifyIds.length === 0) {
        return "全部";
      } else if (this.selectedClassifyIds.length === this.classifyList.length) {
        return "全部";
      } else {
        // 按数字顺序排序并返回逗号分隔的字符串
        return this.selectedClassifyIds.sort((a, b) => a - b).join(',');
      }
    },
  },
};
</script>

<style>
.payment-list-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 8px;
}

.payment-item-wrapper {
  box-sizing: border-box;
  min-width: 0;
}

.payment-item-wrapper .real-box {
  margin: 0;
  padding: 6px 6px 8px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
</style>
